module.exports = __webpack_public_path__ + "static/media/test_attention.ee0eedfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img1/test_attention.png
// module id = 1653
// module chunks = 0